// extracted by mini-css-extract-plugin
export var buttonabout = "bg-module--buttonabout--BHNgS";
export var home = "bg-module--home--CWY2t";
export var header = "bg-module--header--2zymr";
export var pstyles = "bg-module--pstyles--3cro9";